import {
  ApplicantApplicationFeeModel,
  ApplicantApplicationFeeUpdateModel,
  ApplicantBackgroundCheckModel,
  ApplicantBackgroundCheckUpdateModel,
  ApplicantCreditCheckModel,
  ApplicantCreditCheckUpdateModel,
  ApplicantEmploymentInformationModel,
  ApplicantEmploymentInformationUpdateModel,
  ApplicantIdVerificationModel,
  ApplicantIdVerificationUpdateModel,
  ApplicantIncomeVerificationModel,
  ApplicantIncomeVerificationUpdateModel,
  ApplicantReferenceCheckModel,
  ApplicantReferenceCheckUpdateModel,
  UserModel,
  CommonFlowStepModel,
} from 'src/api/models';
import { EnforceKeys } from 'src/utils/types';

export const APPLICANT_FLOW_NAME = 'applicant-flow';

export const ApplicantFlowStepsNames = {
  CreditCheck: 'CreditCheck',
  EmploymentInformation: 'EmploymentInformation',
  IncomeVerification: 'IncomeVerification',
  ReferenceCheck: 'ReferenceCheck',
  BackgroundCheck: 'BackgroundCheck',
  ApplicationFee: 'ApplicationFee',
  IdVerification: 'IdVerification',
} as const;

export type ApplicantFlowStepName =
  (typeof ApplicantFlowStepsNames)[keyof typeof ApplicantFlowStepsNames];

export type ApplicantFlowStepsMap<T> = EnforceKeys<
  typeof ApplicantFlowStepsNames,
  T
>;

type StepDataModels = {
  [ApplicantFlowStepsNames.CreditCheck]: {
    get: ApplicantCreditCheckModel;
    put: ApplicantCreditCheckUpdateModel;
  };
  [ApplicantFlowStepsNames.EmploymentInformation]: {
    get: ApplicantEmploymentInformationModel;
    put: ApplicantEmploymentInformationUpdateModel;
  };
  [ApplicantFlowStepsNames.IncomeVerification]: {
    get: ApplicantIncomeVerificationModel;
    put: ApplicantIncomeVerificationUpdateModel;
  };
  [ApplicantFlowStepsNames.ReferenceCheck]: {
    get: ApplicantReferenceCheckModel;
    put: ApplicantReferenceCheckUpdateModel;
  };
  [ApplicantFlowStepsNames.BackgroundCheck]: {
    get: ApplicantBackgroundCheckModel;
    put: ApplicantBackgroundCheckUpdateModel;
  };
  [ApplicantFlowStepsNames.ApplicationFee]: {
    get: ApplicantApplicationFeeModel;
    put: ApplicantApplicationFeeUpdateModel;
  };
  [ApplicantFlowStepsNames.IdVerification]: {
    get: ApplicantIdVerificationModel;
    put: ApplicantIdVerificationUpdateModel;
  };
};

export type StepData<TStepName extends keyof StepDataModels> =
  StepDataModels[TStepName];

export type ApplicantFlowStepProps<TStepName extends ApplicantFlowStepName> = {
  user: UserModel;
  flowId: string;
  step?: CommonFlowStepModel;
  stepData?: StepData<TStepName>['get'];
  submitStepData: ({}: {
    stepData: StepData<TStepName>['put'];
    shouldNavigateOnSuccess?: boolean;
  }) => void;
  isLoading: boolean;
  navigateToPreviousStep: () => void;
  navigateToNextStep: () => void;
  showErrorMessage: (errorMessage: string) => void;
  refetchResources: () => void;
};
